import React from "react";
import SearchImage from "../../images/search.png";

const ErrorCard = ({
  title = "Error loading data",
  message = "Failed to load data. Please try again.",
  onRetryClick,
  style = {},
}) => {
  return (
    <div className="inventory-state-container" style={style}>
      <img src={SearchImage} alt="" className="state-image" />
      <h2 className="state-title">{title}</h2>
      <p className="state-message">{message}</p>
      {!!onRetryClick && (
        <button className="state-retry-btn" onClick={onRetryClick}>
          Retry
        </button>
      )}
    </div>
  );
};

export default ErrorCard;
